export function createServiceAreaClient(transport) {
    return {
        /**
         * The service areas a tenant has configured
         *
         * Requires scope: service-area:read
         */
        getServiceAreas(lifecycle, limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-areas",
                query: { lifecycle: lifecycle, limit: limit, after: after },
                options,
            });
        },
        /**
         * Get tenant-scoped service area
         *
         * Requires scope: service-area:read
         */
        getServiceAreas2(id, options) {
            return transport.request({
                method: "GET",
                path: `/v1/service-areas/${encodeURIComponent(id)}`,
                options,
            });
        },
        /**
         * Create a new optimistic service-area version
         *
         * Requires scope: service-area:write
         */
        putServiceAreas(id, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/service-areas/${encodeURIComponent(id)}`,
                body,
                options,
            });
        },
        /**
         * Which fiscal jurisdiction a service area sits in
         *
         * Requires scope: service-area:jurisdiction:read
         */
        getTenantsServiceAreasJurisdiction(tenantId, areaId, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/service-areas/${encodeURIComponent(areaId)}/jurisdiction`,
                options,
            });
        },
        /**
         * Record which fiscal jurisdiction a service area sits in
         *
         * Requires scope: service-area:write
         */
        putServiceAreasJurisdiction(areaId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/service-areas/${encodeURIComponent(areaId)}/jurisdiction`,
                body,
                options,
            });
        },
        /**
         * Deterministically evaluate point and product availability
         *
         * Requires scope: service-area:evaluate
         */
        postServiceAreasAvailability(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/service-areas/availability",
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=service-area.js.map